import React, { useEffect, useRef } from 'react';
import './Section1.css';
import image1 from '../assets/Section1Picture2.avif';

const Section1 = () => {
  const sectionRef = useRef(null);
  const rightRef = useRef(null);

  useEffect(() => {
    const adjustHeight = () => {
      if (!sectionRef.current || !rightRef.current) return;

      if (window.innerWidth <= 760) {
        sectionRef.current.style.height = 'auto';
        return;
      }

      const minHeight = window.innerHeight * 0.76; // 76% of screen height
      const rightHeight = rightRef.current.offsetHeight + 85; // padding buffer
      sectionRef.current.style.height = `${Math.max(minHeight, rightHeight)}px`;

    };

    const observer = new ResizeObserver(adjustHeight);
    if (rightRef.current) observer.observe(rightRef.current);

    adjustHeight();
    window.addEventListener('resize', adjustHeight);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', adjustHeight);
    };
  }, []);

  return (
    <section className="section1" ref={sectionRef}>
      <div className="container section1-inner">
        <div className="section1-left">
          <img src={image1} alt="Vendor 1" />
        </div>
        <div className="section1-right" ref={rightRef}>
          <h4 className="section-tag">ABOUT US</h4>
          <h2>A Purposeful Beginning</h2>
          <p className="highlight">
            Maplee is more than just a marketplace — it’s a team of driven individuals working
            day and night to build something meaningful for local vendors across Canada.
          </p>
          <p>
            We’re a startup with big dreams and a simple goal: to give small businesses the platform,
            visibility, and support they deserve. Every vendor who joins us isn’t just a seller —
            they’re part of the journey.
          </p>
          <p>This is just the beginning — and we’re building it together.</p>
        </div>
      </div>
    </section>
  );
};

export default Section1;
